import { useMutation } from '@tanstack/react-query';

import {
  addOffice,
  addVirtualOffice,
  changePrimaryOffice,
  deleteOffice,
  deleteVirtualOffice,
  findAndUpdateOffice,
  findAndUpdateVirtualOffice,
} from 'api';

export function useUpdateOfficeMutation(override = {}) {
  return useMutation({
    mutationFn: findAndUpdateOffice,
    ...override,
  });
}

export function useCreateOfficeMutation(override = {}) {
  return useMutation({
    mutationFn: addOffice,
    ...override,
  });
}

export function useDeleteOfficeMutation(override = {}) {
  return useMutation({
    mutationFn: deleteOffice,
    ...override,
  });
}

export function useChangePrimaryOfficeMutation(override = {}) {
  return useMutation({
    mutationFn: changePrimaryOffice,
    ...override,
  });
}

export function useCreateVirtualOfficeMutation(override = {}) {
  return useMutation({
    mutationFn: addVirtualOffice,
    ...override,
  });
}

export function useUpdateVirtualOfficeMutation(override = {}) {
  return useMutation({
    mutationFn: findAndUpdateVirtualOffice,
    ...override,
  });
}

export function useDeleteVirtualOfficeMutation(override = {}) {
  return useMutation({
    mutationFn: deleteVirtualOffice,
    ...override,
  });
}
